export default __webpack_public_path__ + "static/screen-1-543ea1660435975bb84bc5bf48cbb65b.png";